import { sanitise } from './utilities';

const LINE_BREAK = `
`;
export const tileToString = (tile) => {
    let str = '';
    const key = getItemKeyByType(tile.type.name);
    if (tile.sequence) str += `[${tile.sequence}] `;
    if (tile.type && tile.type.title) str += `[${tile.type.title} screen]` + LINE_BREAK;
    if (tile.title) str += tile.title + LINE_BREAK;
    if (tile.description) str += tile.description + LINE_BREAK;
    const items = tile.object[key];
    if (items && items.length) {
        str += LINE_BREAK + `[${getItemKeyByType(tile.type.name)}]`;
        str += items.map((item, index) => {
            let itemStr = LINE_BREAK + `[${index + 1}] `;
            if (item.date) itemStr += item.date + LINE_BREAK;
            if (item.title) itemStr += item.title + LINE_BREAK;
            if (item.card_back) itemStr += item.card_back + LINE_BREAK;
            if (item.description) itemStr += item.description + LINE_BREAK;
            return itemStr;
        }).join(LINE_BREAK);
    }
    return sanitise(str);
};

export const getItemKeyByType = (type, defaultKey = 'items') => {
    return {
        caseStudy: 'elements',
        iaAcronym: 'letters',
        iaDropTab: 'elements',
        iaFindMistakes: 'tips',
        iaHotspot: 'tips',
        iaIconHover: 'images',
        iaIconPop: 'images',
        iaMenusite: 'details',
        iaPhotoClick: 'images',
        iaPlusPopup: 'images',
        iaSideSlide: 'images',
        iaSpringyCircle: 'elements',
        iaSteps: 'elements',
        iaStepsFlow: 'elements',
        iaWheel: 'slices',
        iaTimeline2: 'categories',
        process: 'elements',
        tapToReveal: 'images',
        slideshow: 'images',
        video: 'images'
    }[type] || defaultKey;
};

export const getImageKeyByType = (type) => {
    return {
        caseStudy: 'image',
        iaDropTab: 'thumb_path',
        iaIconHover: 'image_path',
        iaIconPop: 'image_path',
        iaMenusite: 'item_image',
        iaPhotoClick: 'image_path',
        iaPlusPopup: 'image_path',
        iaSideSlide: 'image_path',
        tapToReveal: 'image_path',
        iaSpringyCircle: 'image_path',
        iaSteps: 'image',
        iaStepsFlow: 'image',
        process: 'image',
        iaTimeline2: 'image_path',
        slideshow: 'image_path'
    }[type] || 'image';
};
